import { noop } from 'lodash';
import { takeUntil } from 'rxjs/operators';

import type { WidgetEffectParams } from '@swf/core/store';
import { pageChange } from '@swf/core/utils/actions';

import type { BasicSportsWidgetConfig } from '../pages/types';

/**
 * Returns a Cancellation Signal (AbortSignal) triggered on page change and
 * widget unmount.
 */
export function getWidgetCancellationSignal<
  T extends BasicSportsWidgetConfig = BasicSportsWidgetConfig
>({ actions, widget }: WidgetEffectParams<T>, abortController?: AbortController) {
  const pageChangeObservable = pageChange(actions);
  const cancellationController = abortController ?? new AbortController();

  pageChangeObservable?.pipe(takeUntil(widget.unmount)).subscribe(
    () => cancellationController.abort(), // Page Change
    noop,
    () => cancellationController.abort() // Unmount
  );

  return cancellationController.signal;
}
